
import Vue from 'vue/dist/vue.js'

export default Vue.extend({
  data() {
    return {
      time: null,
    }
  },
  created() {
    this.set(this.params)
  },
  methods: {
    refresh(params) {
      this.params = params
      this.set(params)
    },
    set(params) {
      const time = params.value.match(/([0-9]{2}:[0-9]{2})/);
      this.time = time[0]
    },
  },
  template: "<div>{{time}}</div>",
})
